import { Title } from '../../../renderApp/components/atoms/Title/Title';
import { SectionTabs } from '../../../shared/components/atoms/SectionTabs/SectionTabs';
import { createGoodsUrlBuilder } from '@services/MarppleShop/features/ProductList/util';
import { Tooltip } from '@services/MarppleShop/renderApp/components/atoms/Tooltip/Tooltip.ts';
import { SectionTitle } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle';

/**
 * @desc
 * 팝업스토어, 큐레이션, 크리에이터 뷰 페이지에서 사용하는 타이틀 컴포넌트
 */
export const makePopupStoreTitle = (
  is_mobile: boolean,
  current_tab_id: 'popup-store' | 'curation' | 'creator_view',
) => {
  return new Title({
    sub_title: ET('mps2::section_title::sub_title::popup_store'),
    title: new SectionTabs({
      size: is_mobile ? 'large' : 'xLarge',
      tabs: [
        {
          id: 'popup-store',
          label: ET('mps2::section_title::section_tabs::popup_store'),
          href: `/${ET.lang}/@/popup-store`,
        },
        {
          id: 'creator_view',
          label: ET('mps2::section_title::section_tabs::creator_view'),
          href: `/${ET.lang}/@/creator_views`,
        },
      ],
      current_tab_id,
    }),
    size: is_mobile ? 'large' : 'xLarge',
  });
};

/**
 * @desc
 * 크리에이터 랭킹, 플러스샵, 크리에이터 탐색 뷰 페이지에서 사용하는 타이틀 컴포넌트
 */
export const makeCreatorRankingTitle = (
  is_mobile: boolean,
  current_tab_id: 'creator_ranking' | 'plus_shop' | 'creator_search',
  tooltipView?: Tooltip,
): SectionTitle => {
  let sub_title: string;
  if (current_tab_id === 'plus_shop') {
    sub_title = ET('mps2::section_title::sub_title::plus_shop');
  } else if (current_tab_id === 'creator_search') {
    sub_title = ET('mps2::section_title::sub_title::creator_search');
  } else {
    sub_title = ET('mps2::section_title::sub_title::creator_ranking');
  }

  return new SectionTitle({
    title_props: {
      sub_title,
      size: is_mobile ? 'large' : 'xLarge',
      title: new SectionTabs({
        size: is_mobile ? 'large' : 'xLarge',
        tabs: [
          {
            id: 'creator_search',
            label: ET('mps2::section_title::section_tabs::creator_search'),
            href: `/${ET.lang}/@/creator/explore`,
          },
          {
            id: 'plus_shop',
            label: ET('mps2::section_title::section_tabs::plus_shop'),
            href: `/${ET.lang}/@/creator/plus`,
          },
        ],
        current_tab_id,
      }),
      tooltip: tooltipView,
    },
  });
};

export const makeRealTimeRankingTitle = (
  is_mobile: boolean,
  current_tab_id: 'realtime' | 'creator_ranking',
  sub_title: string,
): SectionTitle => {
  return new SectionTitle({
    title_props: {
      sub_title,
      size: is_mobile ? 'large' : 'xLarge',
      title: new SectionTabs({
        size: is_mobile ? 'large' : 'xLarge',
        tabs: [
          {
            id: 'realtime',
            label: ET('mps2::recently_sold::title'),
            href: createGoodsUrlBuilder().setPage('LATEST_SOLD').build(),
          },
          {
            id: 'creator_ranking',
            label: ET('mps2::section_title::section_tabs::creator_ranking'),
            href: `/${ET.lang}/@/creator/ranking/realtime`,
          },
        ],
        current_tab_id,
      }),
    },
  });
};
